module.exports = __webpack_public_path__ + "media/images/pic/brodno/test_lessons_bg-beee85659da132f9fc0423c56cbf0224.png";